import { useSearchParams } from "react-router-dom";
import { DialogContent, DialogTitle, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import BaseDialog from "../base-dialog/base-dialog";
import { BaseButton } from "../base-button/base-button";

//import images and icons
import { Add } from "iconsax-react";

//import styles
import "./question-modal.scss";

function QuestionModal({ children, open, setOpen, description, question, colorYes, colorNo, handleClick, close, isLoading }) {
    //general variables
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    //handle close modal
    const handleClose = () => {
        setOpen(false);
        if (!!searchParams.delete("action")) {
            searchParams.delete("action");
            searchParams.delete("id");
            setSearchParams(searchParams);
        }
    };

    return (
        <BaseDialog open={open} handleClose={handleClose} maxWidth="xs" top="auto" icon="close">
            <DialogContent>
                <Grid container item xs={12} rowGap={1}>
                    {children}
                    <Grid className="question-modal__question-text" container item xs={12} justifyContent="center">
                        {question}
                    </Grid>
                    <Grid className="question-modal__question-description" container item xs={12} justifyContent="center" alignItems="center">
                        {description}
                    </Grid>
                    <Grid container item xs={11} justifyContent="space-evenly">
                        <Grid container item xs={4}>
                            <BaseButton
                                text={t("yes")}
                                color={colorYes}
                                radius="radius-10"
                                size="medium"
                                handleClick={handleClick}
                                loading={isLoading}
                            />
                        </Grid>
                        <Grid container item xs={4}>
                            <BaseButton text={t("no")} color={colorNo} radius="radius-10" size="medium" handleClick={close || handleClose} />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </BaseDialog>
    );
}

export default QuestionModal;
